export default __webpack_public_path__ + "static/media/check-green.b4db6695.svg";